import { closedStatusCategoryKey, CustomListCategoryId } from "@sp-crm/core";

const recentlyClosedColumnPrefix = "Recently ";

export const pipelineColumnPrefix = (categoryKey: string | null): string =>
    categoryKey === closedStatusCategoryKey ? recentlyClosedColumnPrefix : "";

export const pipelineColumnTitle = (name: string, categoryKey: string | null): string =>
    `${pipelineColumnPrefix(categoryKey)}${name}`;

export interface CategorizedList {
    categories: { id: CustomListCategoryId; key: string }[];
}

export interface CategorizedListItem {
    customListCategoryId: CustomListCategoryId | null;
}

export const listItemCategoryKey = (
    list: CategorizedList,
    item: CategorizedListItem,
): string | null =>
    list.categories.find(category => category.id === item.customListCategoryId)?.key ??
    null;
